import DiaryRewardsForm from "./js/DiaryRewardsForm";
export default DiaryRewardsForm;